import * as echarts from 'echarts/core';

// echarts exposes no API to query rendered size before drawing — measure it instead via convertToPixel and getDom()+getBBox() (both public).

export function getAxisLinePixelY(chart: echarts.ECharts, yAxisIndex: number = 0): number {
  return chart.convertToPixel({ yAxisIndex }, 0) as number;
}

export function getRenderedContentBBox(chart: echarts.ECharts): { x: number; y: number; width: number; height: number } {
  const svg = chart.getDom().querySelector('svg');
  const group = svg?.querySelector('g');
  if (!group) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  const bbox = (group as unknown as SVGGraphicsElement).getBBox();
  return { x: bbox.x, y: bbox.y, width: bbox.width, height: bbox.height };
}
